import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import AutoCompleteComponent from "../../Components/AutoComplete/AutoComplete";
import FeedsPage from "./FeedsPage";
import APIPage from "./APIPage";
import { getAllClients } from "../../Services/API/ClientManagement";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    backgroundColor: "transparent",
    boxShadow: "none",
    color: theme.palette.primary.main,
    fontWeight: "bold",
    width: "85%",
    zIndex: 0,
  },
  tab: {
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      "& .MuiBox-root": {
        padding: "0px",
      },
    },
  },
  largeIcon: {
    color: theme.palette.primary.main,
    margin: "auto",
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  tabContainer: {},
  autocomplete: {
    width: "20%",
    paddingBottom: "20px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
  },
}));

export default function InboundTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [allClients, setAllClients] = useState([]);
  const [selectedClientID, setSelectedClientID] = useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClientChange = (event, value) => {
    if (value === null) {
      setSelectedClientID(null);
      return;
    }
    for (const x in allClients) {
      if (allClients[x].shortName === value.shortName) {
        setSelectedClientID(allClients[x].id);
      }
    }
  };

  const compare = (a, b) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  };

  useEffect(() => {
    getAllClients().then((response) => {
      response.sort((a, b) => {
        const order = compare(a.shortName, b.shortName);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
      setAllClients(response);
    });
  }, []);

  return (
    <div className="page-container">
      <Breadcrumb />
      <h1 className="page-title">Inbound Feeds</h1>
      <div className={classes.autocomplete}>
        <AutoCompleteComponent
          dropdownItems={allClients}
          propertyName="shortName"
          label="Search for clients..."
          onChange={handleClientChange}
        />
      </div>
      <AppBar position="static" className={classes.root}>
        <Tabs
          value={value}
          onChange={handleChange}
          classes={{ indicator: classes.primary }}
          className={classes.tabContainer}
        >
          <Tab label="Feeds" {...a11yProps(0)} className={classes.tab} />
          <Tab label="API" {...a11yProps(1)} className={classes.tab} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} className={classes.tab}>
        <FeedsPage clientID={selectedClientID} />
      </TabPanel>
      <TabPanel value={value} index={1} className={classes.tab}>
        <APIPage clientID={selectedClientID} />
      </TabPanel>
    </div>
  );
}
